<template>
  <!-- User Profile Edit Product Access Info Tab Content View From Account Profile -->
    <div class="tabs-content-secondblock">
        <div class="row">
            <div class="col-lg-12">
                <div class="ml-2 mr-1 mb-3">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="infoHeader mt-4 py-6 px-4">
                                <span class="fw-700 fs-15">
                                    All Products
                                    <sup class="fs-14 ml-1 mandatory">
                                        <el-tooltip class="item" effect="light" placement="right">
                                            <div slot="content">
                                                Products are listed from the CRM Products module
                                            </div>
                                            <i class="icon-information text-secondary" style="font-size: 14px"></i>
                                        </el-tooltip>
                                    </sup>
                                </span>
                                <span>
                                    <i class="icon-information" style="font-size: 14px"></i> Select or deselect checkbox to request subscription or unsubscribe respectively.
                                </span>
                                <div class="row p-2" style="border: 1px solid #ecf1f9; margin-right: 1px; margin-left: 1px;">
                                    <div class="col-4" v-for="(prod,index) in products" :key="index">
                                        <input type="checkbox" @click="productSelected(prod)" />
                                        <span class="ml-2">{{ prod.product_name }}</span>
                                    </div>
                                </div>
                                <span class="fw-700 fs-15 my-5">
                                    Justification<sup class="fs-14 ml-1 mandatory">*</sup>
                                </span>
                                <textarea v-model="request_justification" maxlength="1000" style="width: 100%; border: 1px solid #ecf1f9; resize: none; height: 10em; padding: 0px 10px; overflow-y: auto" name="justification" v-validate="'required'"></textarea>
                                <span class="editcharacter-count text-grey" style="margin-top: -30px; margin-right: 6px;" >{{ 1000 - request_justification.length }}/1000</span>
                                <span class="invalid-feedback-form text-danger mt-0" v-show="errors.has('justification')">{{ errors.first('justification') }}</span>
                                <span>
                                <button class="btn btn-new-green float-right fs-12 fw-600 my-4" style="border-radius: 18px; text-transform: none;" @click="saveProductAccess">Submit Request</button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { User } from "./mixins/user";
import { EventBus } from "./eventBus/nav-bar-event.js";
export default {
    data() {
        return {
            selectedProducts: [],
            products: [],
            request_justification: "",
        }
    },
    mixins: [User],
    methods: {
        productSelected(prod) {
            if (this.selectedProducts.includes(prod._id)) {
                this.selectedProducts = this.selectedProducts.filter(x => x != prod._id);
            } else {
                this.selectedProducts.push(prod._id);
            }
        },
        async getProducts() {
            let res = await this.$http.get("/company/get_products_purchased_not_purchased");
            if (res.data.status_id == 1) {
                this.products = res.data.response.purchased_products;
            }
        },
        saveProductAccess() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.saveProductAccessConfirm();
                }
            });
        },
        async saveProductAccessConfirm() {
            let params = {
                subscribe: this.selectedProducts,
                request_justification: this.request_justification,
            };
            let res = await this.$http.post("/digi_products/access/request", params);
            if (res.data.status_id == 1) {
                this.$emit("dataSaved");
            }
        },
    },
    mounted() {
        EventBus.$on("hideuser", () => {
            this.hideEdit();
        });
        this.getProducts();
    },
}
</script>


// WEBPACK FOOTER //
// src/components/EditProductAccessView.vue